import React from 'react';
import TooltipConstants from 'shared/constants/TooltipConstants';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/* eslint-disable react/prop-types */

const DurationSuppressionIcon = (props) => {
  const { isRunTimeSuppressed, onChange, withTooltip } = props;

  const icon = isRunTimeSuppressed ? 'hourglass_muted' : 'hourglass_unmuted';

  const passProps = {
    name: icon,
    onClick: () => onChange(!isRunTimeSuppressed),
  };

  if (withTooltip) {
    passProps.tip = TooltipConstants.CSRunTimeSuppression;
  }

  return (
    <div className="duration-picker-suppress-toggle">
      <Icon {...passProps} ours />
    </div>
  );
};

export default DurationSuppressionIcon;
